var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from '@bottlebooks/gatsby-design-system/src/components/icons/sizes';
/**
 * A star icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {'filled' | 'hollow' | 'inverted'} [props.variant]
 * @param {import('@bottlebooks/gatsby-design-system/src/components/icons/sizes').IconSize} [props.size] The icon size.
 */
export default function BookmarkIcon(_a) {
    var { size = 'small', variant = 'filled' } = _a, rest = __rest(_a, ["size", "variant"]);
    switch (variant) {
        case 'hollow':
            return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
                    width: sizes[size],
                    height: sizes[size],
                    verticalAlign: 'sub',
                }, fill: "none", viewBox: "0 0 50 50" }, rest),
                jsx("g", { transform: "matrix(-1 0 0 1 49 1)" },
                    jsx("path", { stroke: "currentColor", fill: "#FFF", d: "M33.547 9.6v24.467c.511 5.777-2.671 5.777-9.547 0-6.876 5.777-10.058 5.777-9.547 0V9.6H14.4h19.2" }))));
        case 'inverted':
            return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
                    width: sizes[size],
                    height: sizes[size],
                    verticalAlign: 'sub',
                }, viewBox: "0 0 50 50", fill: "none" }, rest),
                jsx("g", { stroke: "currentColor", transform: "matrix(-1 0 0 1 49 1)" },
                    jsx("circle", { cx: "24", cy: "24", r: "24", fill: "currentColor" }),
                    jsx("path", { stroke: "currentColor", fill: "#FFF", d: "M33.547 9.6v24.467c.511 5.777-2.671 5.777-9.547 0-6.876 5.777-10.058 5.777-9.547 0V9.6H14.4h19.2" }))));
        case 'filled':
        default:
            return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
                    width: sizes[size],
                    height: sizes[size],
                    verticalAlign: 'sub',
                }, fill: "none", viewBox: "0 0 50 50" }, rest),
                jsx("g", { transform: "matrix(-1 0 0 1 49 1)" },
                    jsx("path", { fill: "currentColor", d: "M33.547 9.6v24.467c.511 5.777-2.671 5.777-9.547 0-6.876 5.777-10.058 5.777-9.547 0V9.6H14.4h19.2" }))));
    }
}
//# sourceMappingURL=BookmarkIcon.js.map